<template>

  <div id="page-user-list">

    <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
      <div class="vx-row">
        <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Cari Data</label>
          <vs-input class="mb-4 md:mb-0 w-full" v-model="searchQuery" @input="updateSearchQuery" placeholder="Masukkan kata kunci..." />
        </div>
        <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Tipe</label>
          <v-select :options="typeOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="typeFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">&nbsp;</label>
          <vs-button @click="$router.push({ name: 'bank-account-cashflow-add', params: { id: $route.params.id } })" class="mb-4 md:mb-0 mt-6" color="primary" type="filled">Tambah Data</vs-button>
        </div>
      </div>
    </vx-card>

    <div class="vx-card p-6 pt-3">
      <div class="cashflow-balance-summary">
        <div><span>Data Ditampilkan</span></div>
        <div><span>Saldo Awal Halaman</span><strong>Rp {{ formatCurrency(openingBalance) }}</strong></div>
      </div>
      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        @grid-ready="onGridReady"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="bankCashflowData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="false"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        :frameworkComponents="frameworkComponents"
        :loadingOverlayComponent="loadingOverlayComponent"
        :loadingOverlayComponentParams="loadingOverlayComponentParams"
      >
      </ag-grid-vue>

      <div class="flex flex-wrap justify-between items-center">

        <!-- ITEMS PER PAGE -->
        <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-3 border border-solid d-theme-border-grey-light rounded d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ totalItems ? (currentPage - 1) * paginationPageSize + 1 : 0 }} - {{ Math.min(currentPage * paginationPageSize, totalItems) }} dari {{ totalItems }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>

              <vs-dropdown-item @click="changePageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="changePageSize(50)">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="changePageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-left">
          <vs-pagination
            :total="totalPages"
            :max="7"
            v-model="currentPage" />
        </div>
      </div>

    </div>

    <vs-popup class="voucher-preview-popup" title="Preview Voucher" :active.sync="voucherPreviewActive">
      <div class="voucher-preview-scroll">
        <div class="vx-card p-6 pt-3" id="voucherPrint">
      <table style="border-collapse: collapse; font-family: sans-serif; font-size: 14px; width: 900px; color: black">
        <tr class="header">
            <td style="border: 2px solid black; padding: 5px; height: 40px; vertical-align: top; width: 20%;">
                <label v-if="print.type == 'KM'">Diterima dari :</label>
                <label v-else>Dibayarkan kepada :</label>
                  <p style="text-align: center; margin-top: 8px; font-size: 16px; font-weight: 600;">{{print.paidTo}}</p>
              </td>
            <td style="border: 2px solid black; padding: 5px; height: 40px; text-align: center; padding: 10px 40px; font-size: 36px; font-weight: 900; font-family: 'Times New Roman'; width: 60%; letter-spacing: -1.5px;" class="title">
              <label style="color: red" v-if="print.type == 'KM'">VOUCHER KAS MASUK</label>
              <label v-else>VOUCHER KAS KELUAR</label>
              <!-- VOUCHER KAS {{ (print.type == 'KM') ? 'MASUK' : 'KELUAR' }} -->
            </td>
            <td style="border: 2px solid black; font-size: 14px; padding: 5px; height: 40px; vertical-align: top; width: 20%">
                Nomor<span style="font-weight: 600; padding: 10px"> : {{print.proof}}</span><br/>
                Tanggal<span style="font-weight: 600; padding: 6px">: {{print.date}}</span>
              </td>
          </tr>
        <tr class="detail-content">
          <td style="border: 2px solid black; border-bottom: none;" colspan="3" class="number">
              <table style="width: 100%; border-collapse: collapse;">
                  <tr class="title" style="text-align: center;">
                    <td style="width: 10%; ">No Akun</td>
                    <td style="width: 70%; border-left: 2px solid black; border-right: 2px solid black;">Uraian</td>
                    <td style="width: 20%;">Jumlah</td>
                  </tr>
                  <tr class="content" style="vertical-align: top; height: 80px">
                    <td style="border-top: 2px solid black; padding: 10px 10px;"></td>
                    <td style="border: 2px solid black; padding: 10px;">
                      <table style="width: 100%">
                        <template v-for="data in print.description">
                        <tr :key="data.id">
                          <template v-if="data.amount !== null && data.amount !== undefined">
                            <td style="border-bottom: 1px solid #E0E0E0" width="80%">{{ data.title }}</td>
                            <td style="border-bottom: 1px solid #E0E0E0" width="2%" align="center">Rp. </td>
                            <td style="border-bottom: 1px solid #E0E0E0" width="18%" align="right">{{data.amount.toLocaleString()}}</td>
                          </template>
                          <template v-else>
                            <td style="border-bottom: 1px solid #E0E0E0" width="80%">{{ data.title }}</td>
                          </template>
                        </tr>
                        </template>
                      </table>
                      <!-- <ul style="list-style-type: circle">
                        <template v-for="data in print.description">
                          <li :key="data.id"> (  )</li>
                        </template>
                      </ul> -->
                    </td>
                    <td style="border-top: 2px solid black; font-size: 16px; border-bottom: 2px solid black; padding: 10px 26px; text-align: center;">
                      <b>Rp. {{print.price}}</b>
                    </td>
                  </tr>
                </table>
            </td>
        </tr>
        <tr class="detail-journal">
          <td colspan="3" style="border: 2px solid black; border-top: none; vertical-align: top; padding: 14px 10px; min-height: 160px">
              <div style="font-size: 14px; font-weight: 700; text-align: center; margin-bottom: 8px;">
                Penjurnalan
              </div>
              <div style="min-height: 100px;"></div>
            </td>
        </tr>
        <tr class="footer">
            <td class="notes" style="border: 2px solid black; font-size: 14px; vertical-align: top; padding: 4px;">
              <label>Catatan :</label>
              <p>{{print.notes}}</p>
            </td>
            <td class="signature" style="border: 2px solid black;" colspan="2">
              <table style="width: 100%; border-collapse: collapse">
                  <tr class="title" style="text-align: center;">
                    <td colspan="5" style="padding: 2px">Tanda Tangan</td>
                  </tr>
                  <tr class="content" style="height: 100px; vertical-align: top; text-align: center;">
                      <td width="20%" class="chairman" style="border-top: 2px solid black;">Pimpinan</td>
                      <td width="20%" class="finance" style="border: 2px solid black; border-bottom: none;">Keuangan</td>
                      <td width="20%" class="cashier" style="border-top: 2px solid black;">Kasir</td>
                      <td width="20%" class="person" style="border: 2px solid black; border-bottom: none;">Yang Mengajukan</td>
                      <td width="20%" class="receiver" style="border-top: 2px solid black;">Penerima</td>
                    </tr>
                </table>
            </td>
        </tr>
          </table>
        </div>
      </div>

      <div class="flex justify-end mt-4">
        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-printer" :disabled="isPrinting" @click="printVoucherPreview">
          {{ isPrinting ? 'Mencetak...' : 'Print Voucher' }}
        </vs-button>
      </div>
    </vs-popup>

    <vx-card ref="filterCard" title="Export Data" subtitle="Export Data ke dalam format excel" class="user-list-filters mt-base">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="vx-row">
            <div class="vx-col w-full md:w-4/12">
              <vs-input type="date" size="medium" label="Dari Tanggal" v-model="startDate" class="w-full mr-2"></vs-input>
            </div>
            <div class="vx-col w-full md:w-4/12">
              <vs-input type="date" size="medium" label="Sampai Tanggal" v-model="endDate" class="w-full mr-2"></vs-input>
            </div>
            <div class="vx-col w-full md:w-4/12">
              <vs-button @click="exportData" class="mb-4 md:mb-0 mt-6" color="primary" type="border">Export Data</vs-button>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>

</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import printElement from '@/utils/printElement'
import voucherPrintDescriptions from '@/utils/voucherPrintDescriptions'
import * as XLSX from 'xlsx'

// Store Module
import moduleBankCashflow from '@/store/bank-cashflow/moduleBankCashflow.js'

// Cell Renderer
import CellRendererActions from './cell-renderer/CellRendererActions.vue'

// Custom loading table
import CustomLoadingOverlay from '@/components/customLoadingOverlay'


export default {
  components: {
    AgGridVue,
    vSelect,
    Datepicker,

    // Cell Renderer
    CellRendererActions
  },
  data () {
    const activeYear = Number(localStorage.getItem('selectedYear')) || new Date().getFullYear()
    const today = moment(new Date()).format('YYYY-MM-DD')
    return {
      startDate: `${activeYear}-01-01`,
      endDate: activeYear === new Date().getFullYear() ? today : `${activeYear}-12-31`,
      openingBalance: 0,
      currentPage: 1,
      totalPages: 0,
      totalItems: 0,
      paginationPageSize: 100,
      dateFilter: null,
      // Filter Options
      typeFilter: { label: 'All', value: 'all' },
      typeOptions: [
        { label: 'All', value: 'all' },
        { label: 'Kas Masuk', value: 'KM' },
        { label: 'Kas Keluar', value: 'KK' }
      ],

      searchQuery: '',
      popupActive: false,
      voucherPreviewActive: false,
      isPrinting: false,

      // AgGrid
      gridApi: null,
      cashflowRequestId: 0,
      gridOptions: {},
      frameworkComponents: null,
      loadingOverlayComponent: null,
      loadingOverlayComponentParams: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
        autoHeight: true,
        suppressMenu: true
      },

      print: {
        paidTo: null,
        type: null,
        proof: null,
        date: null,
        description: [],
        notes: null,
        price: 0,
        journal: null
      },

      columnDefs: [
        {
          headerName: 'No',
          field: 'no',
          width: 80,
          cellStyle (params) {
            if (params.data.type === 'KM') {
              return {color: 'red'}
            }
          }
        },
        {
          headerName: 'Tipe',
          field: 'type',
          filter: true,
          width: 0,
          hide: true,
          cellStyle (params) {
            if (params.data.type === 'KM') {
              return {color: 'red'}
            }
          }
        },
        {
          headerName: 'Notes',
          field: 'notes',
          filter: true,
          width: 0,
          hide: true,
          cellStyle (params) {
            if (params.data.type === 'KM') {
              return {color: 'red'}
            }
          }
        },
        {
          headerName: 'Tanggal',
          field: 'date',
          filter: true,
          width: 150,
          cellStyle (params) {
            if (params.data.type === 'KM') {
              return {color: 'red'}
            }
          }
        },
        {
          headerName: 'Bukti',
          field: 'proof',
          filter: true,
          width: 120,
          cellStyle (params) {
            if (params.data.type === 'KM') {
              return {color: 'red'}
            }
          }
        },
        {
          headerName: 'Dibayarkan Kepada',
          field: 'paidTo',
          filter: true,
          cellStyle (params) {
            if (params.data.type === 'KM') {
              return {color: 'red'}
            }
          }
        },
        {
          headerName: 'Keterangan',
          field: 'description',
          width: 400,
          filter: true,
          getQuickFilterText (params) {
            let descriptions = ''
            if (params.data.description.length > 0) {
              params.data.description.forEach((val) => {
                descriptions += `<li>${val.title}</li>`
              })
            } else {
              descriptions = '-'
            }
            return descriptions
          },
          cellRenderer (params) {
            let descriptions = ''
            if (params.data.description.length > 0) {
              params.data.description.forEach((val) => {
                descriptions += `<li>${val.title}</li>`
              })
            } else {
              descriptions = '-'
            }
            return `<ul style="list-style: circle">${descriptions}</ul>`
          },
          cellStyle (params) {
            if (params.data.type === 'KM') {
              return {'color': 'red', 'white-space': 'normal', 'line-height': 1.5}
            } else {
              return {'white-space': 'normal', 'line-height': 1.5}
            }
          }
        },
        {
          headerName: 'Debit',
          field: 'debit',
          filter: true,
          // width: 150,
          cellClass: 'text-right',
          cellStyle (params) {
            if (params.data.type === 'KM') {
              return {'color': 'red', 'text-align': 'right'}
            } else {
              return {'text-align': 'right'}
            }
          }
        },
        {
          headerName: 'Kredit',
          field: 'credit',
          filter: true,
          width: 150,
          headerClass: 'header-right',
          cellClass: 'text-right',
          cellStyle (params) {
            if (params.data.type === 'KM') {
              return {color: 'red'}
            }
          }
        },
        {
          headerName: 'Saldo',
          field: 'balance',
          filter: true,
          width: 150,
          headerClass: 'header-right',
          cellClass: 'text-right',
          cellStyle (params) {
            if (params.data.type === 'KM') {
              return {color: 'red'}
            }
          }
        },
        {
          headerName: 'Actions',
          field: 'transactions',
          width: 200,
          cellRendererFramework: 'CellRendererActions',
          cellRendererParams: {
            printVoucher : this.printVoucher.bind(this),
            getBankCashflow : this.getBankCashflow.bind(this)
          },
          cellStyle: {'display': 'flex', 'justify-content': 'center'}
        }
      ],
      bankCashflowData: [],
      paymentMethodData: [],

      // Cell Renderer Components
      components: {
        CellRendererActions
      }
    }
  },
  watch: {
    '$route.params.id' (id, previousId) {
      if (id && id !== previousId && this.gridApi) {
        if (this.currentPage !== 1) this.currentPage = 1
        else this.getBankCashflow()
      }
    },
    typeFilter () {
      if (this.currentPage !== 1) this.currentPage = 1
      else this.getBankCashflow()
    },
    dateFilter (obj) {
      this.setColumnFilter('date', obj ? moment(String(obj)).format('YYYY-MM-DD') : 'all')
    },
    currentPage () {
      this.getBankCashflow()
    }
  },
  created () {
    if (!moduleBankCashflow.isRegistered) {
      this.$store.registerModule('bankCashflow', moduleBankCashflow)
      moduleBankCashflow.isRegistered = true
    }
  },
  methods: {
    async onGridReady (params) {
      this.gridApi = params.api
      await this.$nextTick()
      if (!this.gridApi) return
      this.gridApi.sizeColumnsToFit()
      this.gridApi.paginationSetPageSize(this.paginationPageSize)
      if (this.$vs.rtl) {
        const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
        if (header) header.style.left = '-' + String(Number(header.style.transform.slice(11, -3)) + 9) + 'px'
      }
      return this.getBankCashflow()
    },

    changePageSize (size) {
      this.paginationPageSize = size
      if (this.gridApi) this.gridApi.paginationSetPageSize(size)
      if (this.currentPage !== 1) this.currentPage = 1
      else this.getBankCashflow()
    },
    exportData () {
      const rows = this.bankCashflowData.map(item => ({
        Tanggal: item.date,
        Nomor: item.proof,
        Penerima: item.paidTo,
        Tipe: item.type,
        Debit: item.debit,
        Kredit: item.credit,
        Saldo: item.balance,
        Catatan: item.notes
      }))
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(rows), 'Cashflow Bank')
      XLSX.writeFile(workbook, `cashflow-bank-${this.startDate}-${this.endDate}.xlsx`)
    },
    async printVoucher (data) {
      Object.assign(this.print, {
        paidTo: data.paidTo,
        type: data.type,
        proof: data.proof,
        date: data.date,
        notes: data.notes,
        description: voucherPrintDescriptions(data),
        price: (data.type === 'KM') ? data.debit : data.credit,
        journal: data.journal || null
      })

      this.voucherPreviewActive = true
      await this.$nextTick()
    },
    async printVoucherPreview () {
      if (this.isPrinting) return

      this.isPrinting = true

      try {
        await printElement(document.getElementById('voucherPrint'))
      } catch (error) {
        this.$vs.notify({
          title: 'Print gagal',
          text: error && error.message ? error.message : 'Browser tidak dapat membuka dialog print.',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      } finally {
        this.isPrinting = false
      }
    },
    changeDate (e) {
      this.setColumnFilter('date', moment(String(e)).format('YYYY-MM-DD'))
    },
    async getBankCashflow () {
      if (!this.gridApi || !this.$route.params.id) return
      const requestId = ++this.cashflowRequestId
      this.gridApi.showLoadingOverlay()

      try {
        const res = await this.$store.dispatch('bankCashflow/getBankCashflow', {
          bank_account_id: this.$route.params.id,
          perPage: this.paginationPageSize,
          page: this.currentPage,
          search: this.searchQuery,
          type: this.typeFilter.value !== 'all' ? this.typeFilter.value : null
        })
        if (requestId !== this.cashflowRequestId) return
        const data = Array.isArray(res.data.data) ? res.data.data : []

        this.totalPages = res.data.last_page || 0
        this.currentPage = res.data.current_page || 1
        this.totalItems = res.data.total || 0
        this.openingBalance = Number(res.data.opening_balance || 0)
        this.bankCashflowData = data.map((value, index) => ({
          id          : value.id,
          can_modify  : value.can_modify === true,
          employee_id : value.employee ? value.employee.id : value.employee_id,
          no          : index + 1 + ((this.currentPage - 1) * this.paginationPageSize),
          paidTo      : value.paid_to,
          type        : value.type === 'debit' ? 'KM' : 'KK',
          date        : value.date,
          notes       : value.notes,
          proof       : value.number,
          description : value.items || [],
          journal     : value.voucher_journal || null,
          debit       : Number(value.debit || 0).toLocaleString('id-ID'),
          credit      : Number(value.credit || 0).toLocaleString('id-ID'),
          balance     : Number(value.balance || 0).toLocaleString('id-ID')
        }))

        // Let the rowData binding update the grid before completing the loading state.
        await this.$nextTick()
      } catch (err) {
        if (requestId !== this.cashflowRequestId) return
        this.bankCashflowData = []
        this.totalPages = 0
        this.totalItems = 0
        this.openingBalance = 0
        await this.$nextTick()
        const data = err && err.response && err.response.data
        this.$vs.notify({
          color: 'danger',
          title: 'Data Cashflow Bank gagal dimuat',
          text: (data && (data.message || data.error)) || 'Silakan coba lagi.'
        })
      } finally {
        if (requestId === this.cashflowRequestId && this.gridApi) {
          if (this.bankCashflowData.length > 0) this.gridApi.hideOverlay()
          else this.gridApi.showNoRowsOverlay()
        }
      }
    },
    setColumnFilter (column, val) {
      if (!this.gridApi) return
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.typeFilter = this.statusFilter = { label: 'All', value: 'all' }
      this.dateFilter   = null

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.searchQuery = val
      if (this.currentPage !== 1) this.currentPage = 1
      else this.getBankCashflow()
    },
    formatCurrency (value) {
      return Number(value || 0).toLocaleString('id-ID')
    }
  },
  beforeMount () {
    this.frameworkComponents = {
      customLoadingOverlay: CustomLoadingOverlay
    }
    this.loadingOverlayComponent = 'customLoadingOverlay'
    this.loadingOverlayComponentParams = {
      loadingMessage: 'One moment please...'
    }
  },
  beforeDestroy () {
    this.cashflowRequestId++
    this.gridApi = null
  }
}

</script>

<style lang="scss">
  // @import "./style.scss";

.ag-row .ag-cell {
  display: flex;
  align-items: center;
}

.ag-row .text-right {
  flex-direction: row-reverse;
}

.voucher-preview-popup .vs-popup {
  width: 960px;
  max-width: 95vw;
}

.voucher-preview-scroll {
  overflow-x: auto;
}

.cashflow-balance-summary {
  align-items: center;
  background: linear-gradient(90deg, var(--app-primary-soft), var(--app-secondary-soft));
  border: 1px solid var(--app-primary-soft);
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  padding: 12px 16px;
}

.cashflow-balance-summary > div { display: flex; flex-direction: column; }
.cashflow-balance-summary span { color: #64748b; font-size: 10px; }
.cashflow-balance-summary strong { color: var(--app-primary-ink); margin-top: 3px; }

@media print {
  body * {
    visibility: hidden !important;
  }

  #voucherPrint,
  #voucherPrint * {
    visibility: visible !important;
  }

  #voucherPrint {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }
}
</style>
